<template>
    <CContainer>
        <Loading :showIn="'pageLoading'" />

        <CRow>
            <CCol col="12" class="px-0">
                <CreateBtn class="mfe-2" @click="modal = { show: true, editMode: false, item: {id: '', meta: {name: ''},  sale: {action_value: '', action_type: CommissionAmountType.PERCENT}} }" />
            </CCol>
        </CRow>

        <CRow v-if="commissionProduct && commissionProduct.products">
            <CCol col="12" class="px-0 mt-2">
                <CRow>
                    <CCol
                        col="12"
                        md="3"
                        v-for="(item, index) in commissionProduct.products"
                        :key="index"
                    >
                        <CCard class="h-100 hover-it">
                            <CCardBody>
                                <span class="d-block text-right mt-2">{{ item.meta ? item.meta.name : '' }}</span>
                                <span class="mt-1 d-block">
                                    {{ item.sale.action_type === CommissionAmountType.PERCENT ? item.sale.action_value : $numberWithCommas(item.sale.action_value) }}
                                    {{ item.sale.action_type === CommissionAmountType.PERCENT ? $t('percent') : $t('rial') }}
                                </span>
                                <CLink class="edit-it px-1" @click="editModal(item)">
                                    <FaIcon icon="edit" />
                                </CLink>
                                <CLink
                                    class="remove-it px-1"
                                    @click="deleteModal = { show: true, item: Object.assign({}, item) }"
                                >
                                    <FaIcon icon="trash" class="text-danger" />
                                </CLink>
                            </CCardBody>
                        </CCard>
                    </CCol>
                </CRow>
            </CCol>
        </CRow>

        <CModal
            :title="$t('v2commission.category_base.delete')"
            color="danger"
            :show.sync="deleteModal.show"
        >
            <template #body-wrapper>
                <CCard class="b-a-0 m-0">
                    <CCardBody>
                        <span>{{ $t('v2commission.category_base.are_you_sure_to_remove', { attribute: (deleteModal.item.meta ? deleteModal.item.meta.name : '') }) }}</span>
                    </CCardBody>
                </CCard>
                <Loading showIn="deleteModalLoading" />
            </template>

            <template #footer>
                <CButton @click="deleteModal.show = false" color="secondary">{{ $t('cancel') }}</CButton>
                <CButton @click="deleteCategory" color="danger">{{ $t('delete') }}</CButton>
            </template>
        </CModal>
        <CModal color="primary" :show.sync="modal.show">
            <template #header-wrapper>
                <span></span>
            </template>

            <Form
                :product="modal.item"
                :products_cell="products_cell"
                :submit="submit"
                v-if="modal.show"
                :editMode="modal.editMode"
                :products="products"
                @searchOnProduct="fetchProducts"
            />

            <template #footer-wrapper>
                <span></span>
            </template>
        </CModal>
    </CContainer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { Form } from './partials/products'
import { CommissionModel, CommissionType, CommissionAmountType } from '@/constants'
import { firstIndex } from '@/common/objects'
import { groupByArrayOfObject } from '@/common/arrays'
import { productService } from '@/services/api'

export default {
    name: 'Products',

    components: {
        Form
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetchProducts()
        })
    },

    data() {
        return {
            CommissionAmountType,
            storeId: this.$route.params.store_id,
            modal: {
                show: false,
                item: {},
                editMode: false,
            },
            deleteModal: {
                show: false,
                item: {}
            },
            products_cell: {
                id: '',
                sale: {
                    action_value: 0,
                    action_type: CommissionAmountType.PERCENT,
                },
            },
            products: [],
        }
    },

    computed: {
        ...mapGetters({
            productBaseCommissionWhereStoreId: 'v2commission/productBaseCommissionWhereStoreId',
        }),
        commissionProduct() {
            return firstIndex(this.productBaseCommissionWhereStoreId(this.storeId) || {}) || {
                products: []
            }
        },
    },

    methods: {
        ...mapActions({
            create: 'v2commission/create',
            edit: 'v2commission/edit',
            setShowLoading: 'loadingComponent/setShowLoading',
        }),
        fetchProducts(params = {}) {
            params.store_id = this.storeId
            // params.no_paginate = true
            params.just = ['id', 'name']

            productService.fetch(params).then(res => {
                this.products = res.data.data
            })
        },
        editModal(item) {
            this.modal = {
                item: JSON.parse(JSON.stringify(item)),
                show: true,
                editMode: true
            }
        },
        submit() {
            this.setShowLoading('modalLoading')
            const products = Object.assign(
                {},
                groupByArrayOfObject(this.commissionProduct.products, 'id'),
                {[this.modal.item.id]: this.modal.item}
            )

            const data = {
				id: this.commissionProduct.id || undefined,
                model: CommissionModel.PRODUCT_BASE,
                store_id: this.storeId,
                type: CommissionType.MIX,
                products: products,
			}

            const form = data.id ? this.edit(data) : this.create(data)

            form.then(() => {
                this.commissionProduct.products = Object.values(products)
                this.modal = {
                    show: false,
                    item: {}
                }
                this.setShowLoading(false, 'modalLoading')
            })
        },
        deleteCategory() {
            this.setShowLoading('deleteModalLoading')

            const products = this.commissionProduct.products
                .filter(item => item.id !== this.deleteModal.item.id)


            const data = {
				id: this.commissionProduct.id || undefined,
                type: CommissionType.MIX,
                products: products,
			}
            this.edit(data).then(() => {
                this.commissionProduct.products = products
                this.deleteModal = {
                    show: false,
                    item: {}
                }
                this.setShowLoading(false, 'deleteModalLoading')
            })
        },
    }
}
</script>

<style lang="scss" scoped>
::v-deep {
    .hover-it {
        transition: all 0.2s;
        height: 100px;
        display: grid;
        align-items: center;

        a.edit-it,
        a.remove-it {
            position: absolute;
            opacity: 0;
            transition: all 0.5s;
        }

        a.edit-it {
            left: 30px;
            top: 5px;
        }

        a.remove-it {
            left: 10px;
            top: 5px;
        }

        &:hover {
            a.edit-it,
            a.remove-it {
                opacity: 1;
            }
            box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 21, 0.08) !important;
        }
    }
}
</style>